
import * as types from "../constants/action-types";

export default function jobAttentionReducer(state = [], action) {
    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.LOAD_JOBATTENTION_SUCCESS:
        
            return action.items;
        
        default:
            return state;
    };
};


